export default "__VITE_ASSET__3daf9f80__"